import { render } from "./MindMap.vue?vue&type=template&id=3880fa1a&scoped=true&ts=true"
import script from "./MindMap.vue?vue&type=script&lang=ts"
export * from "./MindMap.vue?vue&type=script&lang=ts"

import "./MindMap.vue?vue&type=style&index=0&id=3880fa1a&lang=scss"
import "./MindMap.vue?vue&type=style&index=1&id=3880fa1a&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3880fa1a"]])

export default __exports__